<div class="PageTitle">
    <h3 style="text-align:left; padding-left: 2%; font-family: Roboto,Arial,sans-serif,Nucleo; color: #004f86;">Mailer
        ID Setup</h3>
</div>
<hr>

<div class="row">
    <!-- This card holds the search inputs and buttons for IMB Mailer ID -->
    <div class="col-md-12">
        <mat-card>
            <mat-card-content>

                <div class="row">

                    <div class="col-md-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>IMB Mailer ID</mat-label>
                            <input [formControl]="imbMailerIdControl" matInput placeholder="IMB Mailer ID" value="">
                            <mat-error>Invalid IMB Mailer ID</mat-error>
                        </mat-form-field>
                    </div>

                    <!-- button row for imb search -->
                    <div class="button-row col" style="padding-top: 10px;">
                        <button class="mr-1" mat-flat-button color="primary" (click)="searchButton()" [disabled]="searchDisable">Search</button>
                        <button class="mr-1" mat-flat-button color="primary" (click)="addNewButton()">Add New</button>
                        <button class="mr-1" mat-flat-button color="primary" [disabled]="inactivateDisable"
                            (click)="inactivateButton()">Inactivate</button>
                    </div>

                </div>

            </mat-card-content>
        </mat-card>
    </div>

    <!-- this is the table component for this page for showing imb mailer id existed -->
    <div class="col-md-12" [hidden]="!showTable">
        <mat-card>
            <mat-card-header style="background-color: #004f86; padding: 5px; color: white;">
                <mat-card-title>&nbsp;</mat-card-title>
            </mat-card-header>
            <br>

            <!-- this is where the table show goes -->
            <mat-card-content>
                <div class="mat-elevation-z0 customMaterialDatatable">
                    <table mat-table [dataSource]="dataSource" matSort class="table-striped">

                        <!-- ID Column -->
                        <ng-container matColumnDef="imbMailerId">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> IMB Mailer ID </th>
                            <td mat-cell *matCellDef="let row"> {{row.imbMailerId}} </td>
                        </ng-container>

                        <!-- Progress Column -->
                        <ng-container matColumnDef="imbMailerSequence">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> IMB Mailer Sequence </th>
                            <td mat-cell *matCellDef="let row"> {{row.imbSequence}}</td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="acsMethodCode">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> ACS Method Code </th>
                            <td mat-cell *matCellDef="let row"> {{row.acsMethodCd}} </td>
                        </ng-container>

                        <ng-container matColumnDef="facilityCd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Facility </th>
                            <td mat-cell *matCellDef="let row" [style.color]="row.facilityCd"> {{row.facilityCd}} </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                        </tr>
                    </table>

                </div>
                <div [hidden]="!showTable">
                    <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons aria-label="">
                    </mat-paginator> -->
                </div>

            </mat-card-content>
        </mat-card>

    </div>

    <!-- this is the card for adding new imb mailer id gui -->
    <div class="col-md-12" *ngIf="showAddNewIMBForm">
        <mat-card>
            <mat-card-header style="background-color: #004f86; padding: 5px; color: white;">
                <mat-card-title>Add New IMB Mailer ID</mat-card-title>
            </mat-card-header>
            <br>

            <mat-card-content>
                <form>

                    <div class="row" style="padding-bottom: 10px;">
                        <div class="col">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>IMB Mailer ID</mat-label>
                                <input [formControl]="addImbMailerIdControl" matInput placeholder="IMB Mailer ID"
                                    value="">
                                    <mat-error>Invalid IMB Mailer ID</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row" style="padding-bottom: 10px;">
                        <div class="col">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>IMB Mailer Sequence</mat-label>
                                <input [formControl]="imbMailerSequenceControl" matInput
                                    placeholder="IMB Mailer Sequence" value="">
                                    <mat-error>Invalid IMB Mailer Sequence</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>ACS Method</mat-label>
                                <!-- <input [formControl]="acsMethodControl" matInput placeholder="ACS Method" value=""> -->
                                <mat-select placeholder="Select Options" [formControl]="acsMethodControl">
                                    <mat-option *ngFor="let option of acsMethods" [value]="option"
                                        (click)="setACSMethod()">{{option.referenceDesc}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <mat-form-field appearance="outline" class="w-100" style="width: 300px;">
                                <mat-label>Facility</mat-label>
                                <mat-select placeholder="Select Options" [formControl]="facilityControl">
                                    <mat-option *ngFor="let option of selectOptionList" [value]="option"
                                        (click)="setFacilityDropdown()">{{option.facilityNm}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- button row -->
                    <div class="row">
                        <div class="button-row col" style="padding-top: 10px;">
                            <button class="mr-1" mat-flat-button color="primary" [disabled]="submitDisable"
                                (click)="submitFormButton()">Submit</button>
                            <button class="mr-1" mat-flat-button color="primary" (click)="cancelFormButton()">Cancel</button>
                        </div>
                    </div>

                </form>

            </mat-card-content>

        </mat-card>

    </div>

</div>